
import { createSelector } from 'reselect'
import { IAppState } from '../../store/state.interface.web'

const loginPasswordSuccess = (state: IAppState) => state.login.success
const me = (state: IAppState) => state.login.user
const getLoading = (state: IAppState) => state.login.loading

export const getLoggedInUser = createSelector(
  [me],
  user => user)
export const getLoggedInUseRole = createSelector(
  [me],
  user => user.roleId)
export const getIsSuperUser = createSelector(
  [me],
  user => user.isSuperUser)
export const getIsAdmin = createSelector(
  [me],
  user => user.isAdmin)

export const getLoggedInUserId = createSelector(
  [me],
  user => user.id)

export const getLoginSuccess = createSelector(
  [loginPasswordSuccess],
  success => success
)

export const getLoginLoading = createSelector(
  [getLoading],
  loading => loading
)
